"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDonorFeesCAF = void 0;
const enums_1 = require("../types/enums");
const constants_1 = require("../constants");
const calculatePayPalFee_1 = require("./payPalFees/calculatePayPalFee");
const calculateDonorFeesCAF = ({ amount = 0, coverFees = false, feeCoveredBy = enums_1.FeeCoveredBy.User, isSandbox, applicationFeeSetting = constants_1.DEFAULT_APPLICATION_FEE_EMPLOYEE, applicationFeeAmountCap, isRecurring, donationProvider, }) => {
    if (donationProvider !== enums_1.DonationProvider.CAF) {
        throw Error(`donationProvider must be ${enums_1.DonationProvider.CAF}`);
    }
    // NOTE-ZR - CAF Donations are processed only throught PPGF US for the moment so we need to enforce 'US' countryCode
    const CAF_REROUTED_COUNTRY_CODE = 'US';
    const areFeesCoveredByDeed = feeCoveredBy === enums_1.FeeCoveredBy.Deed;
    // TODO: NOTE-ZR - Ideally this should call its own calculateCAFFee function
    return (0, calculatePayPalFee_1.calculatePayPalFee)({
        amount,
        nonprofitCountryCode: CAF_REROUTED_COUNTRY_CODE,
        applicationFee: areFeesCoveredByDeed ? 0 : applicationFeeSetting,
        applicationFeeAmountCap,
        coverFees,
        isRecurring,
        donationProvider,
        isSandbox,
    });
};
exports.calculateDonorFeesCAF = calculateDonorFeesCAF;
//# sourceMappingURL=calculateDonorFeesCAF.js.map